// extracted by mini-css-extract-plugin
export default {"crumbs":"breadcrumbs_crumbs__QFoQx"};